import React, { useEffect, useState } from "react";
import Navbar from "../components/Sidebar/Sidebar";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import dashboard from "../assets/images/dashboard.jpg";
import Main from "../components/main/Main";
import { PieChart } from "react-minimal-pie-chart";
import axiosInstance from "../api";

const Dashboard = () => {
  // Importing necessary hooks and functions
  const [isAddMenuModalOpen, setAddMenuModalOpen] = useState(false); // State to track if the Add Menu modal is open
  const [admin, isAdmin] = useState(false); // State to track if the user is an admin

  // UseEffect hook to check admin status from localStorage
  useEffect(() => {
    const admin = localStorage.getItem("admin"); // Fetching admin status from localStorage
    isAdmin(admin); // Setting admin state
  }, []);

  // Initializing navigation
  const navigate = useNavigate();

  // Fetching and validating the token stored in localStorage
  const fetchDataValid = async () => {
    const token = localStorage.getItem("token"); // Getting token from localStorage

    if (!token) {
      // If there's no token, redirect to login
      navigate("/login");
      return;
    }

    try {
      // Validating the token with the server
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}/api/auth/validateToken`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`, // Passing the token in the request header
          },
        }
      );

      // If the token is valid, fetch user profile data
      if (response.data.isValid) {
        const userResponse = await axios.get(
          `${process.env.REACT_APP_SERVER}/api/auth/profile`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Passing the token again to get user profile
            },
          }
        );
        setUserName(userResponse.data.name); // Setting user name in state
      } else {
        navigate("/login"); // If token is invalid, redirect to login
      }
    } catch (error) {
      console.error("Error during token validation:", error); // Logging errors
      navigate("/login"); // Redirect to login on error
    }
  };

  // Calling the token validation function on component mount
  useEffect(() => {
    fetchDataValid();
  }, []);

  // State to hold today's menu data
  const [mealToday, setMealToday] = useState([]);

  // Function to format the current date into YYYY-MM-DD format
  const getFormattedDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Adding leading zero to month if needed
    const day = date.getDate().toString().padStart(2, "0"); // Adding leading zero to day if needed

    return `${year}-${month}-${day}`; // Returning formatted date string
  };

  // Fetching today's menu based on the formatted date
  const fetchTodayMenu = async () => {
    try {
      const todayDate = getFormattedDate(); // Getting today's date
      const response = await axiosInstance.get(
        `/api/dish/get-dish-date/${todayDate}` // Fetching the menu for today
      );
      setMealToday(response.data[0].items); // Setting the fetched menu items in state
    } catch (error) {
      console.error("Error fetching menu:", error); // Logging errors if the request fails
    }
  };

  // Calling the fetchTodayMenu function on component mount
  useEffect(() => {
    fetchTodayMenu();
  }, []);

  // State to hold menu data for adding new menu items
  const [menuData, setMenuData] = useState({
    date: "",
    name: "",
    price: "",
    description: "",
    category: "",
    menuType: "",
    dprice: "",
  });

  // Handling form changes and updating the state for menu data
  const handleChange = (e) => {
    const { name, value } = e.target; // Extracting the name and value from the input
    setMenuData((prev) => ({
      ...prev, // Spreading previous state
      [name]: value, // Updating the specific field based on the input name
    }));
  };

  // Handling the form submission to add a new menu item
  const handleSubmit = async (e) => {
    e.preventDefault(); // Preventing default form submission
    try {
      const response = await axiosInstance.post(
        `/api/menu/add-single`, // Sending the menu data to the server to add the menu
        menuData
      );
      toast.success("Menu added successfully!"); // Displaying success message
      setAddMenuModalOpen(false); // Closing the add menu modal
      setMenuData({
        // Resetting the menu form fields
        date: "",
        name: "",
        price: "",
        description: "",
        menuType: "",
      });
      fetchTodayMenu(); // Fetching the updated menu after submission
    } catch (error) {
      console.error("Error adding menu:", error); // Logging errors if the request fails
      toast.error("Failed to add menu. Please try again."); // Displaying error message
    }
  };

  // State to manage the modal for file upload
  const [isModalOpen, setModalOpen] = useState(false);

  // State to store the selected file for upload
  const [selectedFile, setSelectedFile] = useState(null);

  // Handling file input changes
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]); // Setting the selected file to state
  };

  // Handling the file upload for weekly menu
  const handleSubmitWeekLy = async () => {
    if (!selectedFile) {
      // Checking if a file is selected
      toast.info("Please select a file before submitting."); // Displaying message to select a file
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile); // Appending the selected file to formData

    try {
      // Sending the file to the server
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}/api/menu/week`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" }, // Setting correct content type for file upload
        }
      );
      toast.success("File uploaded successfully!"); // Displaying success message
      console.log(response.data); // Logging the server response
    } catch (error) {
      console.error("Error uploading file:", error); // Logging errors if the request fails
      toast.error("Failed to upload file."); // Displaying error message
    }

    setModalOpen(false); // Closing the modal after the file is uploaded
  };

  // State to hold category data for menu items
  const [category, setCategory] = useState([]);

  // Fetching the available categories for menu items
  const fetchSuggestions = async () => {
    try {
      const response = await axiosInstance.get(
        `/api/category/get-category` // Fetching categories from the server
      );
      setCategory(response.data.data); // Setting the categories in state
    } catch (error) {
      console.error("Error fetching suggestions:", error); // Logging errors if the request fails
    }
  };

  // Calling the fetchSuggestions function to fetch categories on component mount
  useEffect(() => {
    fetchSuggestions();
  }, []);

  // State to hold the user's name and remaining days for the menu
  const [userName, setUserName] = useState("");
  const [remainingDays, setRemainingDays] = useState(0);
  const pieChartData = [{ value: remainingDays, color: "black" }]; // Data for the pie chart

  // UseEffect to calculate remaining days for the menu
  useEffect(() => {
    const calculateRemainingDays = async () => {
      try {
        const response = await axiosInstance.get(
          `/menu-left` // Fetching the remaining days from the server
        );

        console.log(response.data); // Logging the server response
        const daysLeft = response.data.count || 0; // Getting the remaining days
        if (daysLeft.length === 0) {
          // If no data is returned, set remaining days to 0
          setRemainingDays(0);
          return;
        }
        setRemainingDays(daysLeft); // Setting the remaining days in state
      } catch (error) {
        console.error("Error fetching remaining days:", error); // Logging errors if the request fails
        toast.error("Failed to calculate remaining days!"); // Displaying error message
      }
    };
    calculateRemainingDays(); // Calling the function to calculate remaining days
  }, []);

  // State to hold menu time data
  const [menuTime, setMenuTime] = useState([]);

  // Fetching the menu time data
  const fetchMenuTime = async () => {
    try {
      const response = await axiosInstance.get(
        `/api/menu-time/get-menu` // Fetching menu time data from the server
      );
      setMenuTime(response.data.data); // Setting menu time data in state
    } catch (error) {
      console.error("Error fetching suggestions:", error); // Logging errors if the request fails
    }
  };

  // Calling the fetchMenuTime function to fetch menu time on component mount
  useEffect(() => {
    fetchMenuTime();
  }, []);

  return (
    <div>
      <Navbar />
      <div className="p-4 sm:ml-64">
        <div className="p-4 border-gray-200 rounded-lg dark:border-gray-700 mt-14">
          <main className="bg-gray-100 grid-area-main overflow-auto mt-0">
            <div className="px-8 py-5">
              <div className="flex flex-col sm:flex-row justify-between items-center sm:items-start sm:px-8">
                {/* Left Section */}
                <div className="flex items-center mb-5 sm:mb-0">
                  <div className="text-[#2e4a66] sm:pl-4">
                    <h1 className="text-2xl sm:text-3xl font-semibold">
                      Hello, {userName || "User"}
                    </h1>
                    <p className="text-sm font-semibold text-[#a5aaad]">
                      Welcome to Cavallo Bianco
                    </p>
                  </div>
                </div>

                {/* Right Section - PieChart */}
                <div className="flex justify-center items-center  sm:mt-0">
                  <h2>Menu Left </h2>
                  <PieChart
                    data={pieChartData}
                    radius={40}
                    lineWidth={15}
                    style={{
                      height: "100px",
                      width: "100px",
                      margin: "auto",
                      transition: "all 0.3s ease-in-out",
                    }}
                    label={({ dataEntry }) => `${dataEntry.value} days`}
                    labelStyle={{
                      fontSize: "10px",
                      fontWeight: "bold",
                      fill: "black",
                    }}
                    animate
                  />
                </div>
              </div>

              <div className="w-full h-auto bg-gradient-to-r from-[#42f5bf] to-[#00bfae] text-white flex flex-col sm:flex-row items-center justify-between px-4 sm:px-8 mb-8 rounded-lg shadow-lg">
                {/* Image Section */}
                <div className="w-full sm:w-1/3 sm:order-1 sm:mt-4 lg:mb-4">
                  <div className="relative w-full h-0 pb-[75%] rounded-lg shadow-md overflow-hidden">
                    {/* 4:3 aspect ratio */}
                    <img
                      src={dashboard}
                      alt="Eggify"
                      className="absolute top-0 left-0 w-full h-full object-cover rounded-lg bg-transparent"
                    />
                  </div>
                </div>

                {/* Text and Button Section */}
                <div className="flex flex-col justify-center space-y-4 w-full sm:w-2/3 sm:pl-8 sm:order-2 mt-6 sm:mt-0 sm:mb-5">
                  <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white text-center sm:text-left ">
                    Welcome to the Cavallo Bianco Admin Dashboard <br />
                    Manage Menus, Orders, and More Effortlessly!
                  </h1>
                </div>
              </div>

              <Main mealToday={mealToday} fetchTodayMenu={fetchTodayMenu} />
            </div>
          </main>
        </div>
      </div>

      {isAddMenuModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-sm sm:max-w-md md:max-w-sm lg:max-w-md xl:max-w-lg p-10 overflow-y-auto max-h-[70vh]">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-bold mb-4">Add Daily Menu</h2>
              {/* Close Icon */}
              <button
                onClick={() => setAddMenuModalOpen(false)}
                className="text-gray-500 hover:text-gray-800 transition-colors duration-200 focus:outline-none"
              >
                <i
                  className="fa fa-times text-xl"
                  style={{ color: "red", fontSize: "30px" }}
                ></i>
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              {/* Date Input */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Enter date
                </label>
                <input
                  type="date"
                  name="date"
                  value={menuData.date}
                  onChange={handleChange}
                  className="mt-1 block w-full border border-black rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
                  required
                />
              </div>

              {/* Category Input */}
              <div className="mb-4">
                <label
                  htmlFor="category"
                  className="block text-sm font-medium text-gray-700"
                >
                  Category
                </label>
                <select
                  name="category"
                  id="category"
                  value={menuData.category}
                  onChange={handleChange}
                  className="mt-1 block w-full border border-black rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
                  required
                >
                  <option value="" disabled>
                    Select category
                  </option>
                  {category.map((category, index) => (
                    <option key={index} value={category.name}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Menu Type Input */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Menu Type
                </label>
                <select
                  name="menuType"
                  value={menuData.menuType}
                  onChange={handleChange}
                  className="mt-1 block w-full border border-black rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
                  required
                >
                  <option value="" disabled>
                    Select Menu Type
                  </option>
                  {menuTime && menuTime.length > 0 ? (
                    menuTime.map((category, index) => (
                      <option key={index} value={category.name}>
                        {category.name}
                      </option>
                    ))
                  ) : (
                    <option value="" disabled>
                      No menu types available
                    </option>
                  )}
                </select>
              </div>

              {/* Menu Name Input */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Menu Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={menuData.name}
                  onChange={handleChange}
                  placeholder="Enter menu name"
                  className="mt-1 block w-full border border-black rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
                  required
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Menu Price
                </label>
                <input
                  type="number"
                  name="price"
                  value={menuData.price}
                  onChange={handleChange}
                  placeholder="Enter menu price"
                  className="mt-1 block w-full border border-black rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
                  required
                />
              </div>

              {/* Menu Discount Price Input */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Menu Discount Price
                </label>
                <input
                  type="text"
                  name="dprice"
                  value={menuData.dprice}
                  onChange={handleChange}
                  placeholder="Enter menu price"
                  className="mt-1 block w-full border border-black rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
                  required
                />
              </div>

              {/* Description Input */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Description
                </label>
                <textarea
                  name="description"
                  value={menuData.description}
                  onChange={handleChange}
                  placeholder="Enter description"
                  className="mt-1 block w-full border border-black rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
                  required
                ></textarea>
              </div>

              {/* Buttons */}
              <div className="flex justify-end">
                <button
                  type="button"
                  className="px-4 py-2 bg-black text-white rounded-md mr-2"
                  onClick={() => setAddMenuModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 text-black rounded-md bg-[#B1D4E0]-100 dark:bg-[#B1D4E0] "
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setModalOpen(false)}
        className="bg-white p-6 rounded-lg shadow-lg max-w-lg mx-auto mt-20"
        overlayClassName="bg-black bg-opacity-50 fixed inset-0 flex justify-center items-center"
      >
        <h2 className="text-2xl font-bold mb-4">Upload Weekly Menu</h2>
        <input
          type="file"
          accept=".xlsx, .xls"
          onChange={handleFileChange}
          className="mb-4"
        />
        <button
          className="px-4 py-2 text-black rounded-md bg-[#B1D4E0]-100 dark:bg-[#B1D4E0] "
          onClick={handleSubmitWeekLy}
        >
          Submit
        </button>
        <button
          className="px-4 py-2 bg-black text-white rounded-md mr-2"
          onClick={() => setModalOpen(false)}
        >
          Cancel
        </button>
      </Modal>
    </div>
  );
};

export default Dashboard;
